import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TuiActionBar } from '@taiga-ui/kit';
import { TuiButton, TuiDataList, TuiExpand, TuiTitle } from '@taiga-ui/core';
import { MOBILE_SCREEN_SIZE } from '@ffx/common';

@Component({
    selector: 'ffx-banner',
    standalone: true,
    imports: [CommonModule, TuiActionBar, TuiExpand, TuiDataList, TuiTitle, TuiButton],
    templateUrl: './banner.component.html',
    styleUrl: './banner.component.scss'
})
export class BannerComponent implements OnInit {
    @Input() bannerMessage = 'Banner message...';
    @Input() confirmText = 'PUBLISH';
    @Input() discardText = 'DISCARD';
    @Input() displayCloseButton = true;
    @Input() isOpen = false;

    @Output() confirmEvent = new EventEmitter<MouseEvent>();
    @Output() discardEvent = new EventEmitter<MouseEvent>();

    isMobile = false;

    ngOnInit(): void {
        this.checkScreenSize();
        window.addEventListener('resize', () => this.checkScreenSize());
    }

    checkScreenSize(): void {
        this.isMobile = window.innerWidth <= MOBILE_SCREEN_SIZE;
    }

    protected closeBanner(): void {
        this.isOpen = false;
    }

    protected confirmClicked(event: MouseEvent): void {
        this.confirmEvent.emit(event);
        this.closeBanner();
    }

    protected discardClicked(event: MouseEvent): void {
        this.discardEvent.emit(event);
        this.closeBanner();
    }
}
